import {useContext} from 'react';

import useIsMobile from '@/src/hooks/useIsMobile';
import ActivePositionsRowLayout from '@/src/jobPortal/clinicPositions/components/ActivePositionsRowLayout';
import EmptyDataWithLink from '@/src/jobPortal/clinicPositions/components/EmptyDataWithLink';
import RouteContext from '@/src/routes/utils/RouteContext';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import css from '../styles/ActiveJobPositionsLayout.module.css';

interface ActiveJobPositionsLayoutProps {
  data: Array<any>;
  onDeleteClick: Function;
  onArchiveClick: Function;
  openVacancyApplicants?: (...args: any) => any;
  isLoading?: boolean;
}

const ActiveJobPositionsLayout = ({
  data,
  onDeleteClick,
  onArchiveClick,
  openVacancyApplicants,
  isLoading,
}: ActiveJobPositionsLayoutProps) => {
  // @ts-ignore
  const {JOB_PORTAL_MY_POSITION_EDIT} = useContext(RouteContext);
  const {isMaxWidth900} = useIsMobile();

  if (!data.length && !isLoading) {
    return <EmptyDataWithLink />;
  }

  return (
    <div>
      <table className={css.tableWithAction}>
        <tbody>
          {isMaxWidth900 ? (
            <tr className={css.tableHeader}>
              <th>
                <TextLocal id={'tables.name'} />
              </th>
              <th>
                <TextLocal id={'tables.applies-viewed'} />
              </th>
              <th>
                <TextLocal id={'tables.actions'} />
              </th>
              <th>
                <TextLocal id={'tables.expiry-date'} />
              </th>
            </tr>
          ) : (
            <tr className={css.tableHeader}>
              <th>
                <TextLocal id={'tables.name'} />
              </th>
              <th>
                <TextLocal id={'tables.viewed'} />
              </th>
              <th>
                <TextLocal id={'tables.applies'} />
              </th>
              <th>
                <TextLocal id={'tables.expiry-date'} />
              </th>
              <th>
                <TextLocal id={'tables.actions'} />
              </th>
            </tr>
          )}

          {data.map((position) => (
            <ActivePositionsRowLayout
              openVacancyApplicants={openVacancyApplicants}
              isMobile={isMaxWidth900}
              id={position.id}
              key={position.id}
              title={position.title}
              onDeleteClick={() => {
                onDeleteClick(position.id, position.title);
              }}
              onArchiveClick={() => {
                onArchiveClick(position.id, position.title);
              }}
              expiredDate={position.expire_date}
              createdAt={position.published_at}
              editLink={JOB_PORTAL_MY_POSITION_EDIT.getLink(position.id)}
              vacancyApplicationsCount={position.vacancy_applications_count}
              uniqueViews={position.vacancy_views_count}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ActiveJobPositionsLayout;
